<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <v-tour
                name="blogisticTour"
                :steps="steps"
                :callbacks="callbacksTour"
              ></v-tour>
              <h4 class="card-title">Relatórios</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table">
                <div class="box-typical-body">
                  <div class="container-fluid">
                    <div class="row loadingDataPosition">
                      <div class="loadingData" v-if="loading">
                        <div class="loadingDataSpinner">
                          <spinner
                            v-if="loading"
                            text-fg-color="#ffffff"
                            message="Carregando..."
                          ></spinner>
                        </div>
                      </div>
                      <div class="container-fluid">
                        <h5>Relatório Posição de frete</h5>
                        <b-row no-gutters>
                          <b-col sm="6" md="2" class="p-0">
                            <b-form-datepicker
                              locale="pt-br"
                              reset-button
                              placeholder="Dt Emissão CTe Inicial"
                              v-model="form.dt_ini"
                              class="form-control"
                              :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                              }"
                              @keyup.enter="doFilter"
                            >
                            </b-form-datepicker>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <b-form-datepicker
                              locale="pt-br"
                              reset-button
                              placeholder="Dt Emissão CTe Final"
                              v-model="form.dt_fim"
                              class="form-control"
                              :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                              }"
                              @keyup.enter="doFilter"
                            >
                            </b-form-datepicker>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <b-form-datepicker
                              locale="pt-br"
                              reset-button
                              placeholder="Data de Expedição Inicial"
                              v-model="form.dt_expedicao_ini"
                              class="form-control"
                              :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                              }"
                              @keyup.enter="doFilter"
                            >
                            </b-form-datepicker>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <b-form-datepicker
                              locale="pt-br"
                              reset-button
                              placeholder="Data de Expedição Final"
                              v-model="form.dt_expedicao_fim"
                              class="form-control"
                              :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                              }"
                              @keyup.enter="doFilter"
                            >
                            </b-form-datepicker>
                          </b-col>
                          <b-col sm="6" md="4" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="unidades"
                              :options="this.unidades2"
                              track-by="value"
                              label="label"
                              :multiple="true"
                              group-values="unidade"
                              group-label="descr"
                              :group-select="true"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Unidade"
                              tag-placeholder=""
                              select-label=""
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              selectGroupLabel="Adicionar todas Unidades"
                              deselectGroupLabel="Remover todas Unidades"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="tpProcessoSelected"
                              :options="tpProcessoOptions"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Tipo de Processo"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <div
                              class="fl-flex-label fl-collapsed fl-background"
                            >
                              <input
                                type="text"
                                class="form-control"
                                v-model="form.num_carga"
                                @keyup.enter="doFilter"
                              />
                              <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                                >N° da carga</label
                              >
                            </div>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="ufEmiSelected"
                              :options="ufOptions"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="UF Emi"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="ufDesSelected"
                              :options="ufOptions"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="UF Dest"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="statusSefazSelected"
                              :options="statusSefazOptions"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Status Sefaz"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col md="2">
                            <multiselect
                              v-model="cargaExpedidaSelected"
                              :options="optionsCargaExpedida"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Carga Expedida"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col md="2">
                            <multiselect
                              v-model="avariaSelected"
                              :options="optionsCargaExpedida"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Avaria/Extravio"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="4" class="p-0">
                            <multiselect
                              v-model="transportadoraSelected"
                              :options-limit="300"
                              :limit="2"
                              :limit-text="limitText"
                              :options="optionsTransportadora"
                              track-by="value"
                              label="label"
                              id="transportadora"
                              :hide-selected="true"
                              placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              :searchable="true"
                              :loading="isLoadingTransportadora"
                              @search-change="listaTransportadora"
                            ></multiselect>
                          </b-col>
                          <b-btn
                            @click="doGerar(1)"
                            variant="secondary"
                            :disabled="isDisabled"
                          >
                            Extrair
                          </b-btn>
                          <b-btn @click="doLimpar(1)" variant="secondary">
                            Limpar
                          </b-btn>
                          <b-col
                            class="p-0"
                            style="
                              display: flex;
                              align-items: center;
                              margin-left: 5px;
                            "
                          >
                            <AvisoErros
                              v-bind:errors_array="errors_array"
                            ></AvisoErros>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import accounting from "accounting";
import AvisoErros from "../../components/AvisoErros";

export default {
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      loading: false,
      isDisabled: false,
      loadingData: false,
      isFullscreen: false,
      showModal: false,
      tpProcessoSelected: [],
      unidades: [],
      carregamentoSelected: [],
      tpNfSelected: [],
      ufEmiSelected: [],
      ufDesSelected: [],
      cargaExpedicaoSelected: [],
      UnidadeOptions: [],
      ufOptions: [],
      unidades2: [
        {
          descr: "Unidades",
          unidade: [],
        },
      ],
      tpProcessoOptions: [],
      avariaSelected: [],
      statusSefazOptions: [],
      statusSefazSelected: [],
      cargaExpedidaSelected: [],
      transportadoraSelected: [],
      transportadora: [],
      errors_array: [],
      optionsTransportadora: [],
      optionsCargaExpedida: [
        { label: "Sim", value: 1 },
        { label: "Nao", value: 0 },
      ],
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
      isLoadingTransportadora: false,
      form: new Form({
        dt_ini: "",
        dt_fim: "",
        dt_expedicao_ini: "",
        dt_expedicao_fim: "",
        tp_processo: "",
        uf_id_origem: "",
        uf_id_destino: "",
        transportadora: "",
        carga_expedida: "",
        num_carga: "",
        avaria: "",
        status_sefaz: "",
        unidades: [],
      }),
    };
  },
  watch: {
    avariaSelected(obj) {
      this.form.avaria = obj.value;
    },
    cargaExpedidaSelected(obj) {
      this.form.carga_expedida = obj.value;
    },
    transportadoraSelected(obj) {
      this.form.transportadora = obj.pessoa_id;
    },
    tpProcessoSelected(obj) {
      this.form.tp_processo = obj.value;
    },
    carregamentoSelected(obj) {
      this.form.carregamento = obj.value;
    },
    tpNfSelected(obj) {
      this.form.tp_nf = obj.value;
    },
    ufEmiSelected(obj) {
      this.form.uf_id_origem = obj.value;
    },
    ufDesSelected(obj) {
      this.form.uf_id_destino = obj.value;
    },
    cargaExpedicaoSelected(obj) {
      this.form.carga = obj.value;
    },
    statusSefazSelected(obj) {
      this.form.status_sefaz = obj.value;
    },
  },
  mounted() {
    this.getLivGeral();
  },
  components: {
    AvisoErros,
  },
  methods: {
    doGerar(cd_relatorio) {
      this.loading = true;
      this.isDisabled = true;
      this.form.unidades = [];
      this.unidades.forEach((obj) => {
        this.form.unidades.push(obj.value);
      });
      this.form
        .post("/api/relatorio/posicaofrete")
        .then((response) => {
          new ReturnApi(response, this);
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    doLimpar() {
      this.tpProcessoSelected = [];
      this.carregamentoSelected = [];
      this.tpNfSelected = [];
      this.ufEmiSelected = [];
      this.unidades_ini = [];
      this.form.unidades = [];
      this.ufDesSelected = [];
      this.avariaSelected = [];
      this.transportadoraSelected = [];
      this.cargaExpedicaoSelected = [];
      this.statusSefazSelected = [];
      this.cargaExpedidaSelected = [];
      this.form.transportadora = [];
      this.form.dt_ini = "";
      this.form.num_carga = "";
      this.form.dt_expedicao_ini = "";
      this.form.dt_expedicao_fim = "";
      this.errors_array = [];
      this.unidades2[0].unidades = [];
      this.unidades = [];
      this.form.dt_fim = "";
    },
    getLivGeral() {
      this.helpForm
        .get("/api/relatorio/posicaofrete/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.unidade.forEach((obj) => {
            this.unidades2[0].unidade.push({
              label: obj.descr,
              value: obj.unidade_id,
            });
          });
          response.uf.forEach((obj) => {
            this.ufOptions.push({
              label: obj.nome,
              value: obj.uf_id,
            });
          });
          response.tp_processo.forEach((obj) => {
            this.tpProcessoOptions.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.status_sefaz.forEach((obj) => {
            this.statusSefazOptions.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsTransportadora.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ).replace(
                      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                      "$1.$2.$3/$4-$5"
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;
      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
